import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    asRed: Palette['primary'];
  }
  interface PaletteOptions {
    asRed?: PaletteOptions['primary'];
  }
}

const isColdTub = () => {
  const brand = localStorage.getItem('data-brand');
  if (brand) return brand === 'coldtub';
  return window.location.hostname.includes('mycoldtub');
};

const coldTub = isColdTub();
const brandColor = coldTub ? '#2aa8c6' : '#a32035';
const brandColorDark = coldTub ? '#35bdd9' : '#b7243d';

const secondaryBrandColor = '#797d82';      
const secondaryBrandColorDark = '#8f949a';

export const theme = createTheme({
  palette: {
    primary: {
      main: brandColor,
      contrastText: '#fff',
    },
    asRed: {
      main: brandColor,
    },
    secondary: {
      main: secondaryBrandColor,
      contrastText: '#fff',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    primary: {
      main: brandColorDark,
      contrastText: '#fff',
    },
    asRed: {
      main: brandColorDark,
    },
    secondary: {
      main: secondaryBrandColorDark,
      contrastText: '#1b1b1b',
    },
  },
});
